import { makeStyles } from "@fluentui/react-components";

export const useClauseDocumentListStyles = makeStyles({
  fieldItem: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    columnGap: "5px",
    rowGap: "5px",
    flexWrap: "wrap",
    width: "100%",
  },
  documentHeader: {
    flex: "0 0 auto",
    display: "inline-block",
  },
});
